<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <el-button
            type="primary"
            size="small"
            @click="addVipEquity"
            :disabled="isDisabled"
            >新建权益</el-button
          >
        </div>
        <div class="header-right">
          <el-button type="danger" size="small" @click="$router.back()">返回</el-button>
        </div>
      </div>
      <div class="tab-content">
        <div class="list">
          <el-table :data="equityList" style="width: 100%">
            <el-table-column label="权益名">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.benefitName }}</div>
              </template>
            </el-table-column>
            <el-table-column label="图标">
              <template slot-scope="scope">
                <div class="name">
                  <img class="icon" :src="scope.row.benefitImage" alt="" />
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" header-align="right">
              <template slot-scope="scope">
                <div class="float-right">
                  <el-button size="small" type="primary" @click="edit(scope.$index)" plain
                    >编辑</el-button
                  >
                  <el-button size="small" type="danger" @click="del(scope.$index)" plain
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogEquityVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="500px"
      @close="resetForm"
    >
      <div slot="title" class="dialog-title">
        {{ equityForm.benefitId ? "编辑权益" : "新建权益" }}
      </div>
      <el-form
        :model="equityForm"
        :rules="rules"
        ref="equityForm"
        label-width="88px"
        class="demo-ruleForm"
        :hide-required-asterisk="true"
        :validate-on-rule-change="false"
      >
        <div>
          <el-form-item label="权益名" prop="benefitName">
            <el-input
              v-model="equityForm.benefitName"
              maxlength="6"
              placeholder="请填写权益名"
            ></el-input>
          </el-form-item>
          <el-form-item label="图标" prop="benefitImage">
            <div class="benefit-image-row">
              <el-select
                v-model="equityForm.benefitImage"
                placeholder="请选择图标"
                popper-class="equity-icon-list"
              >
                <el-option
                  v-for="item in iconList"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                  <img class="icon" :src="item" alt="" />
                </el-option>
              </el-select>
              <img class="icon" :src="equityForm.benefitImage" alt="" />
            </div>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('equityForm')" :loading="isSubmit">
          {{ equityForm.benefitId ? "编辑" : "创建" }}</el-button
        >
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { updateMemberCardBenefit, findMemberCardBenefit } from "@/api";
export default {
  data() {
    return {
      equityList: [],
      dialogEquityVisible: false,
      equityForm: {
        benefitName: "",
        benefitImage: "",
        isEnable: 1,
      },
      oldEquityForm: null,
      rules: {
        benefitName: [
          {
            required: true,
            message: "请填写权益名",
            trigger: "blur",
          },
        ],
        benefitImage: [
          {
            required: true,
            message: "请选择图标",
            trigger: "blur",
          },
        ],
      },
      iconList: [
        "https://img02.163.gg/img/1/94/87/88/1948788-wthiysyypr.png!YM0000",
        "https://img02.163.gg/img/1/94/87/89/1948789-ezcbrukfgk.png!YM0000",
        "https://img02.163.gg/img/1/94/87/87/1948787-lkrplciilx.png!YM0000",
        "https://img02.163.gg/img/1/94/87/82/1948782-yrljqolmyf.png!YM0000",
        "https://img02.163.gg/img/1/94/87/83/1948783-kvigueulln.png!YM0000",
        "https://img02.163.gg/img/1/94/87/86/1948786-ghkplnanmc.png!YM0000",
        "https://img02.163.gg/img/1/94/87/85/1948785-uqedsrrusd.png!YM0000",
        "https://img02.163.gg/img/1/94/87/84/1948784-cshrqbhois.png!YM0000",
        "https://img02.163.gg/img/1/94/87/79/1948779-laylnnuacd.png!YM0000",
        "https://img02.163.gg/img/1/94/87/78/1948778-yeuzeawyyl.png!YM0000",
        "https://img02.163.gg/img/1/94/87/81/1948781-biqlkqhwgf.png!YM0000",
        "https://img02.163.gg/img/1/94/87/77/1948777-obzdmijzhx.png!YM0000",
        "https://img02.163.gg/img/1/94/87/80/1948780-xnbdlwiubm.png!YM0000",
        "https://img02.163.gg/img/1/94/87/76/1948776-swpcthngyl.png!YM0000",
        "https://img02.163.gg/img/1/94/87/75/1948775-qevgxjtjib.png!YM0000",
        "https://img02.163.gg/img/1/94/87/73/1948773-pmtaigryga.png!YM0000",
        "https://img02.163.gg/img/1/94/87/74/1948774-vrsvmfwfmv.png!YM0000",
        "https://img02.163.gg/img/1/94/87/72/1948772-pezvgjhxjo.png!YM0000",
        "https://img02.163.gg/img/1/94/87/70/1948770-ghqttniool.png!YM0000",
        "https://img02.163.gg/img/1/94/87/71/1948771-wisellmcwm.png!YM0000",
        "https://img02.163.gg/img/1/94/87/68/1948768-rfczonogpj.png!YM0000",
        "https://img02.163.gg/img/1/94/87/69/1948769-tehekzants.png!YM0000",
        "https://img02.163.gg/img/1/94/87/64/1948764-iqycqzoeib.png!YM0000",
        "https://img02.163.gg/img/1/94/87/65/1948765-rwwzwexqxr.png!YM0000",
        "https://img02.163.gg/img/1/94/87/67/1948767-qxplcjyvwh.png!YM0000",
        "https://img02.163.gg/img/1/94/87/66/1948766-xzycojiprn.png!YM0000",
        "https://img02.163.gg/img/1/94/87/62/1948762-kfbpgowrha.png!YM0000",
        "https://img02.163.gg/img/1/94/87/63/1948763-zwiqknrbgo.png!YM0000",
        "https://img02.163.gg/img/1/94/87/58/1948758-szvonyizdn.png!YM0000",
        "https://img02.163.gg/img/1/94/87/61/1948761-glrdrzjzzp.png!YM0000",
        "https://img02.163.gg/img/1/94/87/60/1948760-tgyfmbvomi.png!YM0000",
        "https://img02.163.gg/img/1/94/87/59/1948759-pzoofvdzlu.png!YM0000",
        "https://img02.163.gg/img/1/94/87/56/1948756-bcgwjpndwn.png!YM0000",
        "https://img02.163.gg/img/1/94/87/55/1948755-nkenchxzgh.png!YM0000",
        "https://img02.163.gg/img/1/94/87/53/1948753-gvwaozthow.png!YM0000",
        "https://img02.163.gg/img/1/94/87/54/1948754-vllitvmtqn.png!YM0000",
        "https://img02.163.gg/img/1/94/87/52/1948752-pqppaqwlfg.png!YM0000",
        "https://img02.163.gg/img/1/94/87/47/1948747-mhjasmjzho.png!YM0000",
        "https://img02.163.gg/img/1/94/87/50/1948750-jqpwiqmyre.png!YM0000",
        "https://img02.163.gg/img/1/94/87/51/1948751-ndgjjiqqso.png!YM0000",
        "https://img02.163.gg/img/1/94/87/48/1948748-rdguiwmbwd.png!YM0000",
        "https://img02.163.gg/img/1/94/87/46/1948746-shkfdwxnhe.png!YM0000",
        "https://img02.163.gg/img/1/94/87/49/1948749-ljkkzysrok.png!YM0000",
        "https://img02.163.gg/img/1/94/87/45/1948745-orjbwsbznq.png!YM0000",
        "https://img02.163.gg/img/1/94/87/43/1948743-ytolbrkckb.png!YM0000",
        "https://img02.163.gg/img/1/94/87/40/1948740-jbounmjnco.png!YM0000",
        "https://img02.163.gg/img/1/94/87/44/1948744-ajdlefxwzi.png!YM0000",
        "https://img02.163.gg/img/1/94/87/41/1948741-azepvblerq.png!YM0000",
        "https://img02.163.gg/img/1/94/87/42/1948742-cysxlpvvvq.png!YM0000",
        "https://img02.163.gg/img/1/94/87/39/1948739-hfomappkck.png!YM0000",
      ],
      isSubmit: false,
      listIndex: 0,
    };
  },
  computed: {
    isDisabled() {
      if (this.equityList.length < 24) {
        return false;
      }
      return true;
    },
  },
  components: {},
  mounted() {
    this.getPageData();
  },
  methods: {
    getPageData() {
      this.findMemberCardBenefit();
    },
    findMemberCardBenefit() {
      findMemberCardBenefit({
        shopMemberCardId: this.$route.query.shopMemberCardId,
      }).then((res) => {
        if (res.code == 1) {
          this.equityList = res.data;
        }
      });
    },
    addVipEquity() {
      this.resetForm();
      this.dialogEquityVisible = true;
    },
    edit(index) {
      this.resetForm();
      this.equityForm = JSON.parse(JSON.stringify(this.equityList[index]));
      this.listIndex = index;
      this.dialogEquityVisible = true;
    },
    del(index) {
      this.equityForm = this.equityList.splice(index, 1)[0];
      this.updateEquityList("del");
    },
    cancel() {
      this.dialogEquityVisible = false;
    },
    submitForm(formName, cb) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isSubmit = true;
          if (this.equityForm.benefitId) {
            this.equityList[this.listIndex] = this.equityForm;
          } else {
            this.equityList.push(this.equityForm);
          }
          this.updateEquityList(this.equityForm.benefitId ? "edit" : "add");
        } else {
          this.$notify({
            title: "提示",
            message: "表单未完善，请检查店铺设置",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    updateEquityList(type = "add") {
      let equityList = JSON.parse(JSON.stringify(this.equityList));
      console.log(this.equityForm, this.equityList);
      let params = {
        shopMemberCardId: this.$route.query.shopMemberCardId,
        benefitId: this.equityList.length ? this.equityList[0].benefitId : "",
        benefitJson: JSON.stringify(equityList),
      };
      updateMemberCardBenefit(params).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message:
              type == "add" ? "保存成功" : type == "edit" ? "编辑成功" : "删除成功",
            type: type == "del" ? "warning" : "success",
            duration: 2000,
          });
          this.dialogEquityVisible = false;
          this.getPageData();
          this.isSubmit = false;
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "warning",
            duration: 2000,
          });
        }
        this.isSubmit = false;
      });
    },
    resetForm() {
      this.equityForm = {
        benefitName: "",
        benefitImage: "",
        isEnable: 1,
      };
      this.$refs.equityForm && this.$refs.equityForm.resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .bd {
    height: 100%;
    .tab-content {
      height: calc(100% - 63px);
      .list {
        height: 100%;
        width: 100%;
        padding: 0 20px;
      }
    }
  }
  .icon {
    height: 50px;
  }
  .benefit-image-row {
    display: flex;
    align-items: center;
    .icon {
      margin-left: 20px;
    }
  }
}
.map {
  width: 100%;
  height: 400px;
  　　/deep/ .anchorBL {
    display: none;
  }
}
.popup-container {
  text-align: center;
  padding-bottom: 10px;
  .qrcode {
    display: block;
    margin: 10px;
  }
}
</style>

<style lang="less">
.equity-icon-list {
  .el-select-dropdown__item {
    height: 60px;
    text-align: center;
    img {
      height: 50px;
    }
  }
}
</style>
